export default "__VITE_ASSET__BS0gPrm8__"